import Vue from "vue";
import * as ENDPOINTS from "./endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class UsersService {

    // ============= Function to List all Users ============
    static async listUsers({ page, limit, filters, search }) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.USERS, {
                params: {
                    page,
                    limit,
                    filters,
                    search
                }
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    //================== get user dashboard details ===============//

    static async dashboardDetails({startDate, endDate}) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.USERDASHBOARD, {
                params: {
                    startDate,
                    endDate
                }
            });

            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    //================== top 10 transactions ===============//

    static async toptransactions() {
        try {
            let page = 0;
            let limit = 10;
            const { data } = await Vue.http.get(ENDPOINTS.TOP_transactionS, {
                params: {
                    page,
                    limit,
                }
            });

            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }

     //================== transactions page===============//

     static async transactionPage(page) {
        try {
            
            let limit = 10;
            const { data } = await Vue.http.get(ENDPOINTS.TOP_transactionS, {
                params: {
                    page,
                    limit,
                }
            });

            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }

    //================== top 10 transactions ===============//

    static async getCountTransactions() {
        try {

            const { data } = await Vue.http.get(ENDPOINTS.TRANSACTION_COUNT);
            return data
        } catch (error) {
            console.log(error);
            resolveRequestError(error);
        }
    }
    // =========== Function to list details on a user ==========
    static async viewUserTransaction({ id, page, limit }) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.VIEWUSERTRANSACTION + `/${id}`, {
                params: {
                    page,
                    limit
                }
            });
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // =========== Function to list details on a user ==========
    static async viewUsersTrades({ id, page, limit, filters }) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.VIEWUSERTRADES + `/${id}`, {
                params: {
                    page,
                    limit,
                    filters
                }
            });

            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // =========== Function to list details on a user ==========
    static async viewUser({ id }) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.USERDETAILS + `/${id}`);
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ========= Function to Suspend User =======
    static async SuspendUser({ id }) {
        try {
            const { data } = await Vue.http.put(ENDPOINTS.SUSPENDUSER + `/${id}`);
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // =========== Function to Activate User ============
    static async ActivateUser({ id }) {
        try {
            const { data } = await Vue.http.put(ENDPOINTS.ACTIVATEUSER + `/${id}`);
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============== FUNCTION TO BLOCK USER'S WALLET =======
    static async BlockWallet({ id }) {
        try {
            const { data } = await Vue.http.put(ENDPOINTS.BLOCKWALLET + `/${id}`);
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============== FUNCTION TO ACTIVATE USER'S WALLET =======
    static async UnblockWallet({ id }) {
        try {
            const { data } = await Vue.http.put(ENDPOINTS.UNBLOCKWALLET + `/${id}`);
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }
}
